

import React, { memo } from 'react';
import cx from 'classnames';

import { PageHeader } from '../../../ui-kit';
import { defaultBreadcrumbs } from '../constants';

import NavigationTabs from './NavigationTabs';
import '../styles/_elevate-page-header.scss';













const ElevatePageHeader = (props) => {
  const {
    history,
    isMobile = false,
    isAdmin = false,
    defaultIndex,
    title,
    proPackage,
    breadcrumbs = defaultBreadcrumbs,
    rightDrawerToggleBtn,
    openHubSpotConversationsWidget
  } = props;

  const tabListProps = {
    isMobile,
    isAdmin,
    defaultIndex,
    history,
    proPackage,
    rightDrawerToggleBtn,
    openHubSpotConversationsWidget
  };

  return (
    <div
      className={cx('elevate-page-header', {
        'elevate-page-header--mobile': isMobile
      })}>

      <PageHeader
        title={title || 'Elevate'}
        actionBtnIsAlwaysIcon
        actionBtnOnClick={() => {
          history.push('/settings');
        }}
        actionBtnText={isMobile && isAdmin ? 'Settings' : ''}
        actionBtnMobileIcon="settings2"
        secondaryContent={
        !isMobile ? <NavigationTabs {...tabListProps} /> : null}

        breadCrumbs={breadcrumbs}
        rightAddOns={rightDrawerToggleBtn} />

      {isMobile &&
      <NavigationTabs
        className="elevate-template-header__tabs--mobile"
        {...tabListProps} />}


    </div>);

};

export default memo(ElevatePageHeader);